import React from 'react';
import PropTypes from 'prop-types';
import Popup from 'reactjs-popup';
import './PcBangPopup.scss';

const PcBangPopup = ({children, title, onClose, contentStyle, render, ...props}) => (
  <Popup modal contentStyle={{maxWidth: '600px', padding: 0, width: '400px', border: 0, ...contentStyle}} {...props}>
    {close => (
      <div className="pcbang-popup">
        <div className="pcbang-popup__header">
          <h3>{title}</h3>
          {close && (
            <span className="close" onClick={onClose || close}>
              X
            </span>
          )}
        </div>
        <div className="pcbang-popup__body">{children || render(close)}</div>
      </div>
    )}
  </Popup>
);

PcBangPopup.propTypes = {
  title: PropTypes.string.isRequired,
};

export default PcBangPopup;
